import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class VitalsService extends ClientDataService {
  private BP_METHODS_DOC = 'tb_nhtsa_bpmethod'
  private HR_METHODS_DOCS = 'tb_nemsis3_hrmethod'
  private NEURO_LOC_DOCS = 'tb_prneuro_loc'
  private STROKE_SCALE_DOCS = 'tb_stroke_scale'
  private STROKE_SCALE_SCORE_DOCS = 'tb_stroke_scale_score'
  private RESP_EFFORT_DOCS = 'tb_nhtsa_respeffort'
  private PAIN_SCALE_DOCS = 'tb_painscale'
  private UTIL_TIME_PERIOD_DOCS = 'tb_util_time_period'
  private PAIN_QUALITY_FIELD_OPTIONS_DOCS = 'tb_pain_quality_fields-custom'
  private SEDATION_SCALE_OPTIONS_DOCS = 'tb_sedation_scale-custom'
  private ADDITIONAL_PAIN_SCALE_DOCS = 'tb_additional_pain_scales'
  private WITHDRAWAL_SCALE_DOCS = 'tb_withdrawal_scale'
  private WITHDRAWAL_SCALE_TYPE_DOCS = 'tb_withdrawal_scale_type'
  private TEMP_METHOD_DOCS = 'tb_temp_method'
  private ETCO2_TYPE_DOCS = 'tb_etco2_type'
  private RHYTHM_DOCS = 'tb_prrhythm'
  private REGULARITY_DOCS = 'tb_nhtsa_pulserhy'
  private ECG_TYPE_DOCS = 'tb_nemsis3_ecgtype'
  private ECG_TYPE_METHOD_DOCS = 'tb_nemsis3_ecgmethod'
  private PROTOCOL_DOCS = 'v_prprotocol'
  private PROTOCOL_METHOD_DOCS = 'v_protocol_method'
  private EYE_OPENING_RESPONSE_DOCS = 'tb_prgcs_adult_eye_with_pnnv'
  private VERBAL_RESPONSE_DOCS = 'tb_prgcs_adult_verbal_with_pnnv'
  private MOTOR_RESPONSE_DOCS = 'tb_prgcs_adult_motor_with_pnnv'
  private APGAR_APPEARANCE_DOCS = 'tb_apgar_appearance-custom'
  private APGAR_PULSE_DOCS = 'tb_apgar_pulse-custom'
  private APGAR_GRIMACE_DOCS = 'tb_apgar_grimace-custom'
  private APGAR_ACTIVITY_DOCS = 'tb_apgar_activity-custom'
  private APGAR_RESPIRATION_DOCS = 'tb_apgar_respiration-custom'

  async getBpMethods(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BP_METHODS_DOC)
  }

  async getHrMethods(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HR_METHODS_DOCS)
  }

  async getNeuroLoc(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.NEURO_LOC_DOCS)
  }

  async getStrokeScale(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STROKE_SCALE_DOCS)
  }

  async getStrokeScaleScore(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STROKE_SCALE_SCORE_DOCS)
  }

  async getRespirationRateEffort(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESP_EFFORT_DOCS)
  }

  async getPainScale(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PAIN_SCALE_DOCS)
  }

  async getUtilTimePeriods(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.UTIL_TIME_PERIOD_DOCS)
  }

  async getPainQualityFieldOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PAIN_QUALITY_FIELD_OPTIONS_DOCS)
  }

  async getSedationScaleOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SEDATION_SCALE_OPTIONS_DOCS)
  }

  async getAdditionalPainScale(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ADDITIONAL_PAIN_SCALE_DOCS)
  }

  async getWithdrawalScale(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WITHDRAWAL_SCALE_DOCS)
  }

  async getWithdrawalScaleType(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WITHDRAWAL_SCALE_TYPE_DOCS)
  }

  async getTempMethod(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TEMP_METHOD_DOCS)
  }

  async getEtco2(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ETCO2_TYPE_DOCS)
  }

  async getRhythmMethod(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RHYTHM_DOCS)
  }

  async getRegularityMethod(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.REGULARITY_DOCS)
  }

  async getEcgType(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ECG_TYPE_DOCS)
  }

  async getEcgTypeMethod(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ECG_TYPE_METHOD_DOCS)
  }

  async getProtocol(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PROTOCOL_DOCS)
  }

  async getProtocolMethod(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PROTOCOL_METHOD_DOCS)
  }

  async getEyeOpeningResponse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EYE_OPENING_RESPONSE_DOCS)
  }

  async getVerbalResponse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VERBAL_RESPONSE_DOCS)
  }

  async getMotorResponse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MOTOR_RESPONSE_DOCS)
  }

  async getApgarAppearance(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.APGAR_APPEARANCE_DOCS)
  }

  async getApgarPulse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.APGAR_PULSE_DOCS)
  }

  async getApgarGrimace(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.APGAR_GRIMACE_DOCS)
  }

  async getApgarActivity(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.APGAR_ACTIVITY_DOCS)
  }

  async getApgarRespiration(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.APGAR_RESPIRATION_DOCS)
  }
}
